import React from 'react'

import { StyledFieldError } from './styles'
import Icon from '@/atoms/Icon'

const FieldError = (props) => {
  const {
    error,
    touched,
    hasIcon = true,
    ariaDescribedby
  } = props || {}

  if (error && touched) {
    return (
      <StyledFieldError
        className="error"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        id={ariaDescribedby}
      >

        {hasIcon ? (
          <Icon
            name={'alert-triangle'}
            role="img"
            aria-hidden
          />
        ) : null}

        <span>{error}</span>
      </StyledFieldError>
    )
  }

  return null
}

export default FieldError
